import React from 'react'
// import Header from '../Reusables/Header'
// import RBMTable from '../Tables/RBMTable'
import EnhancedTable from '../Tables/AdminAllTables'
import PeriodMultiSelector from '../PeriodMultiSelector';
import PeriodSelector from '../PeriodSelector';
import { useLocation } from 'react-router-dom';


const RBMlevelBudget = () => {
  const location = useLocation();
  console.log(location.pathname);
  return (
    <div className='home-screen' style={{padding:"20px"}}>
    {location.pathname==="/admin/templates"?<PeriodSelector/>:<PeriodSelector/>}
    <EnhancedTable />
     {/* <RBMTable style={{marginTop:"20px",marginRight:"10px"}}/> */}
    </div>
  )
}

export default RBMlevelBudget
